import React, { FC, useMemo, memo } from 'react';
import Step from './step';
import classnames from 'classnames';
import { StepsProps, StepProps, StepsEnum } from './interface';

const Steps: FC<StepsProps> = memo(props => {
  const {
    children,
    horizontalAlign,
    className,
    style,
    current = 0,
    options,
    status,
  } = props;
  const renderChildren = () => {
    let newChildren = children;
    if (Array.isArray(options) && options.length) {
      newChildren = options.map((option, index) => {
        return <Step key={index} {...option} />;
      });
    }
    return React.Children.map(newChildren, (child, index) => {
      const childElement = child as React.FunctionComponentElement<StepProps>;
      const childElementProps = childElement.props;
      if (!childElement.type) return null;
      const { displayName } = childElement.type;
      if (displayName && displayName in StepsEnum) {
        return React.cloneElement(childElement, {
          ...childElementProps,
          className: classnames(childElementProps.className, {
            'yb-steps-step-finish': index < current,
          }),
          status:
            index < current
              ? 'finish'
              : index === current
              ? childElementProps.status || status
              : childElementProps.status,
        });
      }
      console.error('Warning: Steps has a child which is not a Step component');
      return null;
    });
  };
  const classes = useMemo(() => {
    return classnames('yb-steps', className, {
      'yb-steps-left': horizontalAlign === 'left',
      'yb-steps-center': horizontalAlign === 'center',
      'yb-steps-right': horizontalAlign === 'right',
    });
  }, [horizontalAlign]);
  return (
    <div className={classes} style={style}>
      <div className="yb-steps-wrapper">{renderChildren()}</div>
    </div>
  );
});

Steps.defaultProps = {
  horizontalAlign: 'right',
  status: 'process',
};

export default Steps;
